module.exports = __webpack_public_path__ + "img/refresh-right.44187797.png";